/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { growthCenterControllerCreate } from '../fn/growth-center/growth-center-controller-create';
import { GrowthCenterControllerCreate$Params } from '../fn/growth-center/growth-center-controller-create';
import { growthCenterControllerDelete } from '../fn/growth-center/growth-center-controller-delete';
import { GrowthCenterControllerDelete$Params } from '../fn/growth-center/growth-center-controller-delete';
import { growthCenterControllerFindAll } from '../fn/growth-center/growth-center-controller-find-all';
import { GrowthCenterControllerFindAll$Params } from '../fn/growth-center/growth-center-controller-find-all';
import { growthCenterControllerFindById } from '../fn/growth-center/growth-center-controller-find-by-id';
import { GrowthCenterControllerFindById$Params } from '../fn/growth-center/growth-center-controller-find-by-id';
import { growthCenterControllerSearch } from '../fn/growth-center/growth-center-controller-search';
import { GrowthCenterControllerSearch$Params } from '../fn/growth-center/growth-center-controller-search';
import { growthCenterControllerUpdate } from '../fn/growth-center/growth-center-controller-update';
import { GrowthCenterControllerUpdate$Params } from '../fn/growth-center/growth-center-controller-update';
import { growthCenterControllerUpdatePublic } from '../fn/growth-center/growth-center-controller-update-public';
import { GrowthCenterControllerUpdatePublic$Params } from '../fn/growth-center/growth-center-controller-update-public';
import { GrowthCenterDto } from '../models/growth-center-dto';
import { OffsetGrowthCenterResponseDto } from '../models/offset-growth-center-response-dto';

@Injectable({ providedIn: 'root' })
export class GrowthCenterService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `growthCenterControllerFindAll()` */
  static readonly GrowthCenterControllerFindAllPath = '/api/growth-center';

  /**
   * 발달센터 전체 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `growthCenterControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  growthCenterControllerFindAll$Response(params?: GrowthCenterControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GrowthCenterDto>>> {
    return growthCenterControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 발달센터 전체 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `growthCenterControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  growthCenterControllerFindAll(params?: GrowthCenterControllerFindAll$Params, context?: HttpContext): Observable<Array<GrowthCenterDto>> {
    return this.growthCenterControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<GrowthCenterDto>>): Array<GrowthCenterDto> => r.body)
    );
  }

  /** Path part for operation `growthCenterControllerCreate()` */
  static readonly GrowthCenterControllerCreatePath = '/api/growth-center';

  /**
   * 발달센터 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `growthCenterControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  growthCenterControllerCreate$Response(params: GrowthCenterControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<GrowthCenterDto>> {
    return growthCenterControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 발달센터 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `growthCenterControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  growthCenterControllerCreate(params: GrowthCenterControllerCreate$Params, context?: HttpContext): Observable<GrowthCenterDto> {
    return this.growthCenterControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<GrowthCenterDto>): GrowthCenterDto => r.body)
    );
  }

  /** Path part for operation `growthCenterControllerSearch()` */
  static readonly GrowthCenterControllerSearchPath = '/api/growth-center/search';

  /**
   * 발달센터 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `growthCenterControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  growthCenterControllerSearch$Response(params: GrowthCenterControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetGrowthCenterResponseDto>> {
    return growthCenterControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * 발달센터 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `growthCenterControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  growthCenterControllerSearch(params: GrowthCenterControllerSearch$Params, context?: HttpContext): Observable<OffsetGrowthCenterResponseDto> {
    return this.growthCenterControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetGrowthCenterResponseDto>): OffsetGrowthCenterResponseDto => r.body)
    );
  }

  /** Path part for operation `growthCenterControllerFindById()` */
  static readonly GrowthCenterControllerFindByIdPath = '/api/growth-center/{id}';

  /**
   * 발달센터 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `growthCenterControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  growthCenterControllerFindById$Response(params: GrowthCenterControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<GrowthCenterDto>> {
    return growthCenterControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 발달센터 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `growthCenterControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  growthCenterControllerFindById(params: GrowthCenterControllerFindById$Params, context?: HttpContext): Observable<GrowthCenterDto> {
    return this.growthCenterControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<GrowthCenterDto>): GrowthCenterDto => r.body)
    );
  }

  /** Path part for operation `growthCenterControllerDelete()` */
  static readonly GrowthCenterControllerDeletePath = '/api/growth-center/{id}';

  /**
   * 발달센터 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `growthCenterControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  growthCenterControllerDelete$Response(params: GrowthCenterControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return growthCenterControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 발달센터 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `growthCenterControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  growthCenterControllerDelete(params: GrowthCenterControllerDelete$Params, context?: HttpContext): Observable<boolean> {
    return this.growthCenterControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `growthCenterControllerUpdate()` */
  static readonly GrowthCenterControllerUpdatePath = '/api/growth-center/{id}';

  /**
   * 발달센터 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `growthCenterControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  growthCenterControllerUpdate$Response(params: GrowthCenterControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return growthCenterControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 발달센터 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `growthCenterControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  growthCenterControllerUpdate(params: GrowthCenterControllerUpdate$Params, context?: HttpContext): Observable<void> {
    return this.growthCenterControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `growthCenterControllerUpdatePublic()` */
  static readonly GrowthCenterControllerUpdatePublicPath = '/api/growth-center/{id}/public';

  /**
   * 공개 여부 변경.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `growthCenterControllerUpdatePublic()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  growthCenterControllerUpdatePublic$Response(params: GrowthCenterControllerUpdatePublic$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return growthCenterControllerUpdatePublic(this.http, this.rootUrl, params, context);
  }

  /**
   * 공개 여부 변경.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `growthCenterControllerUpdatePublic$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  growthCenterControllerUpdatePublic(params: GrowthCenterControllerUpdatePublic$Params, context?: HttpContext): Observable<void> {
    return this.growthCenterControllerUpdatePublic$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
